import william from "@documents-design/morris";

william.addRule({
  id: william.getRuleID(),
  description: "Avoids messing with Mandataire symbols (m.)",
  contexts: {
    brut: {
      find: /\(\s*m\.\s*\)\s*/gi,
      replace: "(m.)"
    }
  }
});

export default william;
